'use client'

import { createContext, useContext } from 'react'
import { useMachine } from '@xstate/react'
import { navigationMachine } from './navigationMachine'

export type NavigationMachineApi = ReturnType<typeof useMachine<typeof navigationMachine>>

const NavigationMachineContext = createContext<NavigationMachineApi | null>(null)

export function NavigationMachineProvider({ children }: { children: React.ReactNode }) {
  const api = useMachine(navigationMachine)

  return (
    <NavigationMachineContext.Provider value={api}>{children}</NavigationMachineContext.Provider>
  )
}

export function useNavigationMachine() {
  const ctx = useContext(NavigationMachineContext)
  if (!ctx) throw new Error('useNavigationMachine must be used within NavigationMachineProvider')
  return ctx
}

export function useNavigationMachineOptional() {
  return useContext(NavigationMachineContext)
}
